<template>
  <section class="page-wrap">
    <!-- 表单 start -->
    <div class="search">
      <div class="search-item">
        <label>供货单号：</label>
        <!-- 输入的供货单号 -->
         <el-input
          v-model="fromData.supplier_order_no"
          placeholder="输入供货单号"
          clearable
        ></el-input>
        <!-- <el-select
          filterable
          v-model="fromData.supplier_order_id"
          clearable
          placeholder="选择供货单号"
        >
          <el-option
            v-for="item in supplierOrderNoList"
            :key="item.id"
            :label="item.supplier_order_no"
            :value="item.id"
          >
          </el-option>
        </el-select> -->
      </div>
      <div class="search-item">
        <label>货号：</label>
        <el-input
          v-model="fromData.sku_code"
          placeholder="输入货号"
          clearable
        ></el-input>
      </div>
      <div class="search-item">
        <label>商品名称：</label>
        <el-input
          v-model="fromData.product_title"
          placeholder="输入商品名称"
          clearable
        ></el-input>
      </div>
      <div class="search-item">
        <label>城市仓：</label>
        <el-select
          filterable
          v-model="fromData.store_logistics_id"
          clearable
          placeholder="选择城市仓"
        >
          <el-option
            v-for="item in cityStoreList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="search-item">
        <label>自提点：</label>
        <el-select
          filterable
          v-model="fromData.store_delivery_id"
          clearable
          placeholder="选择自提点"
        >
          <el-option
            v-for="item in selfTakeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="search-item">
        <label>供货商：</label>
        <el-select
          filterable
          v-model="fromData.supplier_id"
          clearable
          placeholder="选择供货商"
        >
          <el-option
            v-for="item in supplierList"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="search-item">
        <label>业务员：</label>
        <el-select
          filterable
          v-model="fromData.buyer_id"
          clearable
          placeholder="选择业务员"
        >
          <el-option
            v-for="item in buyerList"
            :key="item.id"
            :label="item.fullname"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="search-item">
        <label>送货员：</label>
        <el-input
          v-model="fromData.supplier_deliver_name"
          placeholder="输入送货员"
          clearable
        ></el-input>
      </div>
      <div class="search-item">
        <label>是否缺货：</label>
        <el-select
          v-model="fromData.is_stockout"
          clearable
          placeholder="选择是否缺货"
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="缺货" value="1"></el-option>
          <el-option label="不缺货" value="0"></el-option>
        </el-select>
      </div>
      <div class="search-item">
        <label>供货日：</label>
        <el-date-picker
          v-model="fromData.date"
          type="date"
          placeholder="选择供货日"
          value-format="yyyy-MM-dd"
          clearable
        >
        </el-date-picker>
      </div>
      <div class="search-item">
        <el-button
          class="bjsearch"
          type="primary"
          icon="el-icon-refresh"
          @click="onHandleRefresh"
        ></el-button>
      </div>
      <div class="search-item">
        <el-button @click="onHandleSearch" type="primary" icon="el-icon-search"
          >查询</el-button
        >
      </div>
      <div class="search-item">
        <el-button @click="onHandleExport" type="warning" icon="el-icon-upload2"
          >导出</el-button
        >
      </div>
    </div>
    <!-- 表单 end -->
    <!-- table start -->
    <div class="table-wrap">
      <el-table
        v-loading="loading"
        border
        :data="dataList"
        height="100%"
        style="width: 100%"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
        tooltip-effect="dark"
      >
        <el-table-column type="index" width="80" align="center" label="序号">
        </el-table-column>
        <el-table-column
          label="供货单号"
          prop="supplier_order_no"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{
              scope.row.supplier_order
                ? scope.row.supplier_order.supplier_order_no
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column label="送货员" prop="deliver_name" align="center">
        </el-table-column>
        <el-table-column label="货号" align="center">
          <template slot-scope="scope">
            {{
              scope.row.supplier_order_detail
                ? scope.row.supplier_order_detail.sku_code
                : scope.row.sku_code
            }}
          </template>
        </el-table-column>
        <el-table-column label="商品名称" align="center">
          <template slot-scope="scope">
            {{
              scope.row.supplier_order_detail
                ? scope.row.supplier_order_detail.sku_name
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column label="供货商" align="center">
          <template slot-scope="scope">
            {{
              scope.row.supplier_order && scope.row.supplier_order.supplier
                ? scope.row.supplier_order.supplier.title
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column label="业务员" align="center">
          <template slot-scope="scope">
            {{
              scope.row.supplier_order && scope.row.supplier_order.buyer
                ? scope.row.supplier_order.buyer.fullname
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column label="城市仓" align="center">
          <template slot-scope="scope">
            {{
              scope.row.store_logistics ? scope.row.store_logistics.name : ""
            }}
          </template>
        </el-table-column>
        <el-table-column label="自提点" align="center">
          <template slot-scope="scope">
            {{ scope.row.delivery ? scope.row.delivery.name : "" }}
          </template>
        </el-table-column>
        <el-table-column label="是否缺货" align="center" prop="stockout_text">
        </el-table-column>
        <el-table-column label="缺货件数" prop="qc_number" align="center">
        </el-table-column>
        <el-table-column label="是否确认上车" align="center" prop="deliver_text">
        </el-table-column>
        <el-table-column label="上车件数" prop="deliver_num" align="center">
        </el-table-column>
        <el-table-column label="上车视频" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="handleViewClick(scope.row)"
            >
              查看
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="上车记录" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="handleCheckRecordClick(scope.row)"
            >
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fy">
      <el-pagination
        type="primary"
        align="right"
        background
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="fromData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- table end -->
    <CheckRecordDialogForm ref="checkRecordDialogForm" />
    <!-- 视频弹窗 start -->
    <VideoPlayerDialog
      :visible.sync="videoDialogVisible"
      :videoList="videoList"
    />
    <!-- 视频弹窗 end -->
  </section>
</template>

<script>
import {
  getDeliveryRecord,
  getEntruckDeliverylist,
  postBuyerSelectList,
  postSupplierSelectList,
  getDeliveryVideo,
  exportDeliveryRecord,
} from "@/api/logisticsControl/delivery/index";
import CheckRecordDialogForm from "./modules/boarding-record-modal/index.vue";
import VideoPlayerDialog from "@/components/common/VideoPlayerDialog/index.vue";
import {
  OUT_STOCK_ENUM,
  REVIEW_STATUS_ENUM,
  IS_RETURN_ENUM,
  IS_CHECK_ENUM,
} from "../utils/enum";
import { downLoadFlowBlob } from "@/utils/tools/base";
import { BASE } from "@/api";
import url from "url";
export default {
  name: "ToReviewLog",
  components: {
    CheckRecordDialogForm,
    VideoPlayerDialog,
  },
  data() {
    return {
      fromData: {
        supplier_order_id: "",
        store_logistics_id: "",
        store_delivery_id: "",
        supplier_id: "",
        sku_code: "",
        product_title: "",
        buyer_id: "",
        supplier_deliver_name: "",
        is_stockout: "",
        date: (() => {
          const date = new Date();
          return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
            2,
            "0"
          )}-${String(date.getDate()).padStart(2, "0")}`;
        })(),
        page: 1,
        pageSize: 10,
      },
      // supplierOrderNoList: [], // 供货单号列表
      buyerList: [], // 业务员列表
      supplierList: [], // 供货商列表
      cityStoreList: [], // 城市仓列表
      selfTakeList: [], // 自提点列表
      dataList: [],
      currentPage: 1,
      total: 0,
      loading: false,
      OUT_STOCK_ENUM,
      REVIEW_STATUS_ENUM,
      IS_RETURN_ENUM,
      IS_CHECK_ENUM,
      videoDialogVisible: false,
      videoList: [],
    };
  },
  created() {
    this.onHandleSearch();
    this.getAjaxCityStoreList();
    this.getAjaxSelfTakeList();
    // this.getAjaxSupplierOrderNoList();
    this.getAjaxBuyerList();
    this.getAjaxSupplierList();
  },
  methods: {
    // 获取城市仓列表
    getAjaxCityStoreList: async function () {
      const params = {
        name: "",
        page: 1,
        pageSize: 1000,
      };
      try {
        const { data } = await this.$api.logistics.entruckLogisticslist(params);
        this.cityStoreList = data.data;
      } catch (err) {
        console.log("ajx getAjaxCityStoreList err", err);
      }
    },
    /**
     * 获取自提点列表
     */
    getAjaxSelfTakeList: async function () {
      const params = {
        from: "qc",
        page: 1,
        pageSize: 10000,
      };
      try {
        const { data } = await this.$api.logistics.entruckDeliverylist(params);
        this.selfTakeList = data.data;
      } catch (err) {
        console.log("ajx getAjaxSelfTakeList err", err);
      }
    },
    /**
     * 获取供货单号列表
     */
    // async getAjaxSupplierOrderNoList() {
    //   try {
    //     const { data } = await getEntruckDeliverylist();
    //     this.supplierOrderNoList = data;
    //   } catch (err) {
    //     console.log("ajx getAjaxSupplierOrderNoList err", err);
    //   }
    // },
    /**
     * 获取业务员列表
     */
    async getAjaxBuyerList() {
      try {
        const { data } = await postBuyerSelectList();
        this.buyerList = data;
      } catch (err) {
        console.log("ajx getAjaxBuyerList err", err);
      }
    },
    /**
     * 获取供货商列表
     */
    async getAjaxSupplierList() {
      try {
        const { data } = await postSupplierSelectList();
        this.supplierList = data;
      } catch (err) {
        console.log("ajx getAjaxSupplierList err", err);
      }
    },
    /**
     * 刷新数据
     */
    onHandleRefresh() {
      // 清空搜索
      const date = new Date();
      const dateStr = `${date.getFullYear()}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

      this.fromData = {
        supplier_order_id: "",
        store_logistics_id: "",
        store_delivery_id: "",
        supplier_id: "",
        sku_code: "",
        product_title: "",
        buyer_id: "",
        supplier_deliver_name: "",
        is_stockout: "",
        date: dateStr,
        page: 1,
        pageSize: 10,
      };
      this.onHandleSearch();
    },
    /**
     * 搜索
     */
    onHandleSearch() {
      try {
        // TODO
        this.fromData.page = 1;
        this.currentPage = 1;
        this.onHandleData();
      } catch (err) {
        console.log("ajax err", err);
      }
    },
    /**
     * 请求列表数据
     */
    async onHandleData() {
      this.loading = true;
      try {
        const params = {
          ...this.fromData,
        };
        // 查找供货单号
        // if (params.supplier_order_id) {
        //   const order = this.supplierOrderNoList.find(
        //     (item) => item.id === params.supplier_order_id
        //   );
        //   if (order) {
        //     params.supplier_order_no = order.supplier_order_no;
        //   }
        // }
        const { data } = await getDeliveryRecord(params);
        this.dataList = data.data || [];
        this.total = data.total;
        this.currentPage = params.page;
      } catch (err) {
        console.log("ajax getDeliveryRecord err", err);
      } finally {
        this.loading = false;
      }
    },
    /**
     * 编辑
     */
    handleEditClick(row) {},
    /**
     * 查看视频
     */
    async handleViewClick(row) {
      try {
        const params = {
          entruck_detail_id: row.id,
        };
        const { data } = await getDeliveryVideo(params);
        this.videoList = data || [];
        this.videoDialogVisible = true;
      } catch (err) {
        console.log("ajax getDeliveryVideo err", err);
      }
    },
    /**
     * 查看上车记录
     */
    handleCheckRecordClick(row) {
      this.$refs.checkRecordDialogForm.show(row);
    },
    /**
     * 导出
     */
    onHandleExport() {
      try {
        const query = {
          ...this.fromData,
          token: sessionStorage.getItem("token"),
        };
        // if (query.supplier_order_id) {
        //   const order = this.supplierOrderNoList.find(
        //     (item) => item.id === query.supplier_order_id
        //   );
        //   if (order) {
        //     query.supplier_order_no = order.supplier_order_no;
        //   }
        // }
        delete query.page;
        delete query.pageSize;
        let path = BASE.PRO2 + "/supplier/order/deliver/record/export";
        let params = url.format({ query });
        console.log("🆒", path + params);
        window.open(path + params);
      } catch (err) {
        console.log("export err", err);
      }
    },
    /**
     * 更新了每页数据
     */
    onHandleSizeChange(val) {
      this.fromData.pageSize = val;
      this.onHandleData();
    },
    /**
     * 更新了页码
     */
    onHandleCurrentChange(val) {
      this.fromData.page = val;
      this.currentPage = val;
      this.onHandleData();
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrap {
  padding: 6px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  .search {
    padding: 15px;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    background: #fff;
  }
  .bjsearch {
    background: #333333;
    border-color: #333333;
  }
  .el-button--warning.is-disabled {
    background: #1389ae;
    border-color: #1389ae;
  }
  .fy {
    box-sizing: border-box;
    padding: 10px 20px;
  }

  .search-item {
    .el-input {
      width: 207px;
    }
    .el-select {
      width: 207px;
    }
  }
  .a-center {
    align-content: center;
  }

  .table-wrap {
    margin-top: 20px;
    padding: 15px;
    background: #fff;
    flex-grow: 1;
    overflow-y: scroll;
  }
}
</style>
